import { IMAGES } from "../data/content";

const STATS = [
  { id: "stat-films-completed", value: "25+", label: "Feature Films" },
  { id: "stat-commercials", value: "50+", label: "Commercials / Advertisement" },
  { id: "stat-render-ontime", value: "99.9%", label: "Render On-Time" },
];

const PIPELINE = ["NUKE", "HOUDINI", "UNREAL ENGINE 5", "MAYA", "BLENDER", "DAVINCI RESOLVE", "SUBSTANCE", "KATANA"];
const LOCATIONS = ["CHENNAI", "BANGALORE"];

export const About = () => (
  <section id="about" data-testid="about-section" className="py-24 px-4 sm:px-8 lg:px-16 relative overflow-hidden">
    <div className="absolute inset-0 lens-flare pointer-events-none" />
    <div className="max-w-7xl mx-auto relative">
      <div className="grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <p className="font-mono2 text-xs tracking-[0.35em] text-amber-500/90 mb-4">THE STUDIO</p>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-wide text-zinc-50">
            BUILT BY ARTISTS.<br /><span className="text-stroke">RUN LIKE A LAUNCH PAD.</span>
          </h2>
          <p className="mt-6 text-zinc-300 leading-relaxed max-w-xl">
            Kingdom of Theatrical Horizon is an artist-owned VFX house founded by two visionary
            industry professionals with over two decades of combined experience in visual effects
            and post-production.
          </p>
          <p className="mt-4 text-zinc-300 leading-relaxed max-w-xl">
            Today, we operate two studios in Chennai and Bangalore, bringing together creative
            talent, technical expertise, and a production pipeline built to deliver high-quality
            visual effects for ambitious screen productions.
          </p>
          <p className="mt-4 text-zinc-300 leading-relaxed max-w-xl">
            Our strength lies in combining the scale and capabilities of a modern VFX studio with
            the personal attention of an artist-led house. We remain intentionally hands-on,
            ensuring that experienced supervisors stay closely involved throughout the creative
            process — with every frame receiving the attention it deserves.
          </p>
          <p className="mt-4 font-heading font-semibold text-amber-500/90 leading-relaxed max-w-xl">
            Built by artists. Driven by craft. Trusted to bring extraordinary stories to life.
          </p>
          <div className="mt-8 flex flex-wrap gap-2">
            {PIPELINE.map((t) => (
              <span key={t} className="font-mono2 text-[10px] tracking-[0.2em] border border-white/15 px-3 py-1.5 text-zinc-400">{t}</span>
            ))}
          </div>
          <div className="mt-8 font-mono2 text-xs tracking-[0.3em] text-zinc-500">
            {LOCATIONS.map((l, i) => (
              <span key={l}>{l}{i < LOCATIONS.length - 1 && <span className="text-amber-500 mx-3">/</span>}</span>
            ))}
          </div>
        </div>
        <div className="relative">
          <img src={IMAGES.cameraOp} alt="Camera operator on set" className="w-full aspect-[4/5] object-cover border border-white/10" />
          <div className="absolute -bottom-6 -left-6 bg-amber-500 text-[#070709] px-6 py-4 font-display text-2xl tracking-wide">
            ON SET. ON SCHEDULE.
          </div>
        </div>
      </div>

      <div className="mt-24 grid grid-cols-1 sm:grid-cols-3 border border-white/10 divide-x divide-y sm:divide-y-0 divide-white/10">
        {STATS.map((s) => (
          <div key={s.id} data-testid={s.id} className="p-8 text-center bg-[#0E0E12]">
            <div className="font-display text-4xl sm:text-5xl text-amber-500">{s.value}</div>
            <div className="font-mono2 text-[10px] sm:text-xs tracking-[0.25em] text-zinc-400 mt-2 uppercase">{s.label}</div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
